import { CANNON_CATALOG, type CannonRarity } from '@kenocyber/shared';

/**
 * Cannon artwork resolution.
 *
 * Every rarity has its own PNG and its own texture key. An earlier build
 * loaded the Excellent art under a single `'cannon'` key and reused it for
 * every rarity, so Perfect and Anomaly rendered the wrong image; keeping the
 * key derived from the rarity makes that impossible to repeat.
 *
 * The asset id always comes from the typed catalog - never a hard-coded file
 * name and never a conditional scattered through the renderer.
 */

export function cannonTextureKey(rarity: CannonRarity): string {
  return `cannon-${rarity}`;
}

/**
 * Asset id of a rarity's art.
 *
 * Never null: every cannon that exists has its own PNG. The artless case, and
 * the filter that skipped it, existed only for the planned fourth cannon —
 * that update was cancelled (ADR 0132).
 */
export function cannonAssetId(rarity: CannonRarity): string {
  return CANNON_CATALOG[rarity].assetId;
}
